import { SyncSectionName } from './IIntegrationSync'

export const SyncSectionStatusArray = ['ALWAYS', 'ON_CREATE', 'NEVER'] as const
export type SyncSectionStatus = typeof SyncSectionStatusArray[number]

export const syncSectionStatusValidationsMap: { [key in SyncSectionName]: (SyncSectionStatus | "TWO_WAY")[] } = {
  "INFO": ["ALWAYS", "TWO_WAY", "NEVER", "ON_CREATE"],
  "DESCRIPTION": ["ALWAYS", "TWO_WAY", "NEVER", "ON_CREATE"],
  "FOSTER": ["ALWAYS", "NEVER", "ON_CREATE"],
  "PICTURES": ["ALWAYS", "TWO_WAY", "NEVER", "ON_CREATE"],
  "PRICE": ["ALWAYS", "TWO_WAY", "NEVER", "ON_CREATE"],
  "VIDEOS": ["ALWAYS", "NEVER", "ON_CREATE"],
  "CHARACTERISTICS": ["ALWAYS", "TWO_WAY", "NEVER", "ON_CREATE"],
  "ADOPTION_PATH": ["ALWAYS", "NEVER", "ON_CREATE"],
  "ALLOW_ADOPT_BUTTON": ["ALWAYS", "NEVER", "ON_CREATE"],
  "VISIBILITY": ["ALWAYS", "NEVER", "ON_CREATE"],
}

export default interface IIntegrationSyncSection {
  uuid: string,
  name: SyncSectionName,
  status: SyncSectionStatus
}
